<template>
  <div class="service">
    <h3 class="title">{{ sidebarTitle }}</h3>
    <hr />
    <el-menu >
      <template v-for="(item, index) in list">
        <template>
          <el-menu-item
            :key="index"
            :index="item.index"
            collapse="true"
          >
            <span @click="dianji(item)" :key="index"  :class="{'hh-active':item.path===$route.path}">{{ item.name }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
    <h3 class="title">服务指南</h3>
    <hr />
    <h4 class="til">开馆时间</h4>
    <h5 class="tips" v-if="List.length" v-html="List[0].value"></h5>
    <h4 class="til">美术馆地址</h4>
    <div class="map">
      <baidu-map
        style="height: 103px"
        @ready="mapHandle"
        :scroll-wheel-zoom="true"
        :key="map.longitude"
      ></baidu-map>
    </div>
    <button @click="gotoMenu()" class="order">参展预约</button>
  </div>
</template>
<script>
export default {
  name: "rightBox",
  props: {
    sidebarTitle: {
      type: String,
      default: "",
    },
    list: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      List: [],
        map:{
            longitude: 1,
            latitude: 1,
            address:'',
           },
      current: 0,
    };
  },
  mounted() {
    var that = this;
    console.log("this", this);
    this.$axios
      .get(
        "/frontapi/service/information/list?pageNum=1&pageSize=10&name=开馆时间"
      )
      .then(
        function (res) {

          that.List = res.data.rows;

        },
        function () {
          console.log("请求失败");
        }
      );
    this.$axios({
      method: "get",
      url: "/frontapi/service/information/mapCoordinate",
      data: {},
    }).then((res) => {
      if (res.data.mapCoordinate) {
        var arr = res.data.mapCoordinate.split(",");
        this.map.longitude = parseFloat(arr[0]);
        this.map.latitude = parseFloat(arr[1]);
        this.map.address = res.data.address;
      }
    });
  },
  methods: {
    change(index) {
      this.current = index;
    },
    dianji(item) {
      console.log(item, "item");
      this.$router.push({ path: item.path }).catch((err) => {});
    },
    gotoMenu() {
      //指定跳转的地址 this.$router.replace('/menu')
      this.$router.replace("/spectatorService/appointment");
    },
    mapHandle({ BMap, map }) {
      var point = new BMap.Point(this.map.longitude, this.map.latitude);
      map.centerAndZoom(point, 13);
      var icon = new BMap.Icon(
        require("../assets/imgs/map-position.png"),
        new BMap.Size(74, 84)
      );
      var marker = new BMap.Marker(point, { icon: icon }); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      var html = [];
      var opts = {
        width: 250,
        height: 30,
      };

      html.push('<div class="mapTipWindow"> <ul>');
      html.push("<li>"+this.map.address+"</li>");
      html.push("</ul></div>");
      var infowindow = new BMap.InfoWindow(html.join(""), opts);
      marker.addEventListener("click", function () {
        this.openInfoWindow(infowindow);
      });
    },
  },
};
</script>
<style scoped>

.service {
  width: 309px;
  height: 903px;
  background: #ffffff;
  float: right;
  margin-top: 40px;
  padding: 0 30px;
  border-radius: 10px;
}
.title {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  line-height: 25px;
  margin-top: 30px;
}
.til {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #222222;
  line-height: 56px;
}
.service .el-menu {
  border-right: none;
  margin-bottom: 70px;
}
.service li {
  border-bottom: 1px solid #eeeeee;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #999999;
  line-height: 56px;
  cursor: pointer;
  padding-left: 0 !important;
  background: none;
}
.el-menu-item.is-active {
  color: #999999;
}
#sidebar .el-menu-item:hover {
    background-color: #fff;
}
.hh-active {
  color: #b78c0d !important;
}
.service hr {
  height: 1px;
  border: none;
  border-top: 1px solid #222222;
  margin-top: 30px;
}

.tips {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  line-height: 26px;
}
.order {
  width: 100%;
  height: 40px;
  border: 1px solid #b78c0d;
  border-radius: 4px 4px 4px 4px;
  background: #fff;
  color: #b78c0d;
    font-size: 18px;
  margin-top: 20px;
  cursor: pointer;
}
</style>
